import { render } from "./FPluginPathRecord.vue?vue&type=template&id=3881646c&scoped=true"
import script from "./FPluginPathRecord.vue?vue&type=script&lang=js"
export * from "./FPluginPathRecord.vue?vue&type=script&lang=js"

import "./FPluginPathRecord.vue?vue&type=style&index=0&id=3881646c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3881646c"]])

export default __exports__